import { ICopyable } from '../../common/icopyable';
import { EditableRecordInterface } from './EditableRecordInterface';

export class BatchRecord<T extends EditableRecordInterface> implements ICopyable<BatchRecord<T>> {
    public isDeleted: boolean = false;
    public isEdited: boolean = false;
    public isNew: boolean = false;

    originalDatas: Map<string, any>;

    get editableId(): string | number {
        return this.data.editableId;
    }

    constructor(public data: T) {
        this.originalDatas = new Map<string, any>();
    }

    public createCopy(): BatchRecord<T> {
        let instance = new BatchRecord<T>(this.data);
        instance.isNew = this.isNew;
        instance.isDeleted = this.isDeleted;
        instance.isEdited = this.isEdited;
        instance.originalDatas = this.originalDatas;
        return instance;
    }

    public copyFrom(other: any) {
        this.isNew = other.isNew;
        this.isDeleted = other.isDeleted;
        this.isEdited = other.isEdited;
        this.originalDatas = other.originalDatas;
    }

    public static createInstance<T extends EditableRecordInterface>(type: new () => T) {
        let record = new type();

        let instance = new BatchRecord<T>(record);
        instance.isNew = true;
        return instance;
    }
}
